import $ from 'jquery'


export class AuthenticationFormsLoader {

  constructor() {
    this.$wrapper = $('#authentication-modal-wrapper')
    $('.authentication-loader').on('click', () => this.load())
  }

  load(login_form){
      //if (login_form == 'coord') {
      //  var url = window.authenticationCoordModalsURL
      // } else {
        var url = window.authenticationModalsURL
      //}
      $.get(url).then((response) => {
        this.$wrapper.html(response)
        this.open(login_form)
        new RegisterCoordForm($('#register-coord-modal'));
        new LoginForm($('#authentication-modal'));
        new ForgotPasswordForm($('#forget-password-modal'), $('#forget-password-confirmed-modal'));
        new RegisterForm($('#register-modal'));
      })
  }

  open(login_form) {
    if (login_form == 'coord') {
      this.$wrapper.find('#register-coord-modal').modal('show');
    } else {
      this.$wrapper.find('#authentication-modal').modal('show');
    }
    $('#navbarSupportedContent').collapse('hide');
  }
}


class AuthenticationBaseForm {

  constructor (selector) {
    this.$modal = selector
    this.$form = selector.find('form')
    this.$form.on('submit', (e) => {this.submitForm(e)})
    this.$formError = this.$form.find('.form-error')
  }

  submitForm(e) {
    e.preventDefault()
    this.$form.find('.text-danger').remove()
    $.ajax({
        url: this.$form.attr('action'),
        method: 'POST',
        data: this.$form.serialize(),
        dataType: "json"
    }).then((response) => {
        this.onSuccess(response)
    }).catch((err) => {
        this.onError(err)
    })
    return false
  }

  onError(err) {
    var err_txt = err.responseJSON.form.errors[0]
    if(err_txt !== undefined) {
      this.$form.prepend(
        '<div class="text-field-group text-danger form-error">' + err_txt + '</div>'
      )
    }
    var f_info = undefined;
    for (var f_name in err.responseJSON.form.fields) {
      f_info = err.responseJSON.form.fields[f_name]
      var err_txt = f_info.errors[0]
      var label = f_info.label
      if(err_txt !== undefined) {
        this.$form.find('#id_' + f_name).parent().append(
          '<div class="text-danger">' + err_txt + '</div>'
        )
      }
    }
  }

}


export class LoginForm extends AuthenticationBaseForm {
  onSuccess(response) {
    let next_location = response.location
    if (next_location == '/') {
      // This is the default LOGIN_REDIRECT_URL but we don't want to go there
      location.reload()
    } else {
      // Ifwe have a specific URL different of LOGIN_REDIRECT_URL, go there
      // ex : /accounts/pro for the pro users
      location.href = next_location
    }
  }
}


export class ForgotPasswordForm extends AuthenticationBaseForm {
  constructor (selector, selectorConf) {
    super(selector)
    this.$confModal = selectorConf
  }
  onSuccess(response) {
        this.$modal.modal('hide')
        this.$confModal.modal('show')
  }
}


export class RegisterForm extends AuthenticationBaseForm {
  onSuccess(response) {
    location.reload()
  }
}


export class RegisterCoordForm extends AuthenticationBaseForm {
  onSuccess(response) {
    location.reload()
  }
}





// WEBPACK FOOTER //
// ./skippair/static/js/components/authentication-modal.js